<template>
  <ValidationProvider name="description" slim vid="description">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="audience_description"> Description </BaseFormLabel>
        <BaseFormTextarea id="audience_description" v-model="description" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: Boolean,
  },
  computed: {
    description: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
